import Component from './Planets';

export default Component;